import React from 'react';
import { Route, RouteProps, useHistory, BrowserRouterProps } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ApiRole } from '@ibe/api';
import { useAuthenticate } from '@ibe/tupvid-components';
import { useMount } from 'react-use';
import PageUrl from '../Models/PageUrl';

interface Props {
  redirectTo: string;
  children: React.ReactChild;
  requiredRoles: ApiRole[];
}

const ProtectedRoute = observer(
  ({
    children,
    requiredRoles,
    redirectTo,
    ...routeProps
  }: Props & RouteProps & BrowserRouterProps) => {
    const authHook = useAuthenticate();
    const history = useHistory();
    // const { location } = routeProps;
    // const destinationUrl = location ? location.pathname + location.search : undefined;
    const { token } = authHook.authenticateState;

    useMount(() => {
      if (token) {
        authHook.authenticateService.fromJwt(token);
      } else {
        history.push(redirectTo || PageUrl.LOGIN);
      }
      // if (token) {
      //   authHook.authService.fromJwt(token);
      //   if (
      //     requiredRoles.length > 0 &&
      //     authHook.authService.state.role !== null &&
      //     requiredRoles.includes(authHook.authService.state.role)
      //     // eslint-disable-next-line no-empty
      //   ) {
      //   } else {
      //     history.push(redirectTo || PageUrl.LOGIN);
      //   }
      // } else {
      //   history.push(redirectTo || PageUrl.LOGIN, destinationUrl);
      // }
    });

    // eslint-disable-next-line react/jsx-props-no-spreading,@typescript-eslint/explicit-function-return-type
    return <Route {...routeProps} render={() => children} />;
  }
);

export default ProtectedRoute;
